"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Alert = function Alert(_ref) {
  var type = _ref.type,
      message = _ref.message,
      title = _ref.title,
      dismissible = _ref.dismissible,
      dismissed = _ref.dismissed,
      onDismiss = _ref.onDismiss;

  var _useState = (0, _react.useState)(dismissed),
      _useState2 = _slicedToArray(_useState, 2),
      localDismissed = _useState2[0],
      setLocalDismissed = _useState2[1];

  (0, _react.useEffect)(function () {
    setLocalDismissed(dismissed);
  }, [dismissed]);

  var onCloseClicked = function onCloseClicked() {
    setLocalDismissed(true);
    onDismiss && onDismiss();
  };

  if (dismissible && localDismissed) {
    return null;
  }

  var titleElement = title ? _react["default"].createElement("p", null, ' ', _react["default"].createElement("strong", null, " ", title, " "), ' ') : '';
  var dismissibleClass = dismissible ? 'alert-dismissible' : '';
  var dismissibleButton = dismissible ? _react["default"].createElement("button", {
    type: "button",
    className: "close",
    onClick: onCloseClicked
  }, "\xD7") : '';
  return _react["default"].createElement("div", {
    className: "alert alert-".concat(type, " ").concat(dismissibleClass)
  }, dismissibleButton, titleElement, message);
};

Alert.propTypes = {
  type: _propTypes["default"].oneOf(['success', 'info', 'warning', 'danger']),
  message: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].node,
  dismissible: _propTypes["default"].bool,
  dismissed: _propTypes["default"].bool,
  onDismiss: _propTypes["default"].func
};
Alert.defaultProps = {
  dismissible: true,
  dismissed: false,
  type: 'danger'
};
var _default = Alert;
exports["default"] = _default;